<template>
    <tool-panel ref="panel" @close="$emit('close')">
        <template #header>
            <tool-panel-header
                :title="$t('about.open_manual')"
                :fullscreen="$refs.panel?.isFullscreen"
                @toggle-fullscreen="$refs.panel.toggleFullscreen()"
                @close="$refs.panel.close()"
            />
        </template>
        <div class="help-body">
            <div v-if="!url" class="help-loading">
                <font-awesome-icon icon="spinner" spin />
            </div>
            <iframe v-else :src="url" class="help-frame" />
        </div>
    </tool-panel>
</template>

<script>
import ToolPanel from './ToolPanel.vue'
import ToolPanelHeader from './ToolPanelHeader.vue'
import { restApi } from '../mixins/RestApiMixin.js'

export default {
    name: 'HelpPanel',
    components: { ToolPanel, ToolPanelHeader },
    mixins: [restApi],
    emits: ['close'],
    data() {
        return { url: null }
    },
    mounted() {
        this.restFetch(this.clickhelpUrl, (response) => {
            if (response?.data) {
                this.url = 'https://help.sitowise.com/articles/routa-selainsovellus?t=' + response.data
            }
        })
    }
}
</script>

<style scoped>
.help-body {
    flex: 1;
    display: flex;
    overflow: hidden;
}
.help-frame {
    flex: 1;
    border: none;
    width: 100%;
    height: 100%;
}
.help-loading {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.5em;
    color: #aaa;
}
</style>
